/* global axios */
import ApiClient from './ApiClient';

class UserStatusLogsAPI extends ApiClient {
  constructor() {
    super('user_status_logs', { accountScoped: true });
  }

  get({ page, since, until: untilTs, userId, status } = {}) {
    return axios.get(this.url, {
      params: { page, since, until: untilTs, user_id: userId, status },
    });
  }

  download({ since, until: untilTs, userId, status } = {}) {
    return axios.get(`${this.url}/download`, {
      params: { since, until: untilTs, user_id: userId, status },
      responseType: 'blob',
    });
  }

  pdfUrl({ since, until: untilTs, userId, status, userToken } = {}) {
    const params = new URLSearchParams();
    if (since) params.set('since', since);
    if (untilTs) params.set('until', untilTs);
    if (userId) params.set('user_id', userId);
    if (status) params.set('status', status);
    if (userToken) params.set('user_access_token', userToken);
    const query = params.toString();
    return `${this.url}/pdf${query ? `?${query}` : ''}`;
  }
}

export default new UserStatusLogsAPI();
